module.exports = __webpack_public_path__ + "img/11-6.f6811ed8.png";